import { useState, useEffect } from 'react';

const useDelay = (time, targetValue, initialValue) => {
  const [value, setValue] = useState(time > 0 ? initialValue : targetValue);

  useEffect(() => {
    if (time > 0) {
      const timer = setTimeout(() => setValue(targetValue), time);
      return () => clearTimeout(timer);
    }

    setValue(targetValue);
  }, [targetValue, time]);

  return value;
};

export default useDelay;
